module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<div class=\"container-fluid mainWrapper\">\n  <!-- <app-homedashboard *ngIf=\"isAutharized\"></app-homedashboard> -->\n  <app-seller-header *ngIf=\"isAutharized && isSellerBase\"></app-seller-header>\n  <app-worker-header *ngIf=\"isAutharized && isWorkerBase\"></app-worker-header>\n    <router-outlet></router-outlet>\n  <!-- <app-dashboard></app-dashboard> -->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main